export const handleHeapErrorHandling = () => {
  setTimeout(() => {
    const errorElems = document.getElementsByClassName('p4');
    const errorList = { fields: [], errors: [] };
    for (let i = 0; i < errorElems.length; i += 1) {
      const errorParentElem = errorElems[i].parentElement;
      const errorInput = errorParentElem.querySelector('input');
      if (errorInput) {
        errorList.fields.push(errorInput.getAttribute('id'));
        errorList.errors.push(errorElems[i].innerText);
      }
    }
    if (errorList.fields.length > 0) {
      window.heap?.track('CheckoutError', { ErrorField: errorList.fields.join(', '), ErrorMsg: errorList.errors.join(', ') });
    }
  }, 1);
};

export default handleHeapErrorHandling;
